import { useTranslation } from "react-i18next";

import { FieldErrorV2 } from "../FieldErrorV2";

export const FormErrorMessages = ({
  error,
  id,
}: {
  error: string;
  id?: string;
}) => {
  const { t } = useTranslation();
  return (
    <div
      className="flex flex-col gap-2"
      data-testid={id ?? "form-error-message"}
    >
      <div className="rounded-lg bg-background-failed p-3">
        <FieldErrorV2 text={t(error as any)} />
      </div>
    </div>
  );
};
